import React, { useState, useEffect } from 'react'
import { TextField, MenuItem, Box, Select, OutlinedInput, InputLabel, FormControl } from '@mui/material'
import styled from 'styled-components'
import { useWorkplaces } from 'hooks/useWorkplaces'

const StyledTextField = styled(TextField)`
  && {
    width: ${(props: { width: string }) => props.width};
  }
`

export const WorkplaceSelector: React.FC<{
  width?: string
  fullWidth?: boolean
  selectedWorkplaces: Array<number>
  handleSelectedWorkplaceChange: any
  disabled?: boolean
}> = (props) => {
  const workplaceQuery = useWorkplaces()

  if (workplaceQuery.data === undefined) return null

  return (
    <Box>
      {!workplaceQuery.isLoading && (
				<FormControl fullWidth={props.fullWidth || false}>
					<InputLabel id="workplace-selector-label">Рабочее место</InputLabel>
					<Select
						labelId="workplace-selector-label"
						value={props.selectedWorkplaces}
						fullWidth={props.fullWidth || false}
						onChange={(event) =>
							props.handleSelectedWorkplaceChange(event.target.value)
						}
						input={<OutlinedInput label="Рабочее место" />}
						multiple
						disabled={props.disabled || false}
					>
						{workplaceQuery.data.body.map((workplace) => {
							return (
								<MenuItem value={workplace.id} key={workplace.id}>
									{' '}
									{workplace.name}{' '}
								</MenuItem>
							)
						})}
					</Select>
				</FormControl>
      )}
    </Box>
  )
}

export default WorkplaceSelector
